export const refs = {
    furnitureList: document.querySelector(".furniture-list-render"),
    productModal: document.querySelector('.furniture-details-modal'),
    productMadalContainer: document.querySelector('.furniture-modal-product'),
    modalOrderBtn: document.querySelector('.order-btn'),
    modalCloseBtn: document.querySelector(".modal-furnt-close-btn"),
    categoriesList: document.querySelector(".menu-list-section-iv"),
    loadMoreListBtn: document.querySelector(".btn-load-more-list"),
    orderModal: document.querySelector('.order-modal'),
    flOneBtn: document.querySelector(".fl-one"),
    swiperContainer: document.querySelector('#popular-products-list'),  
}

